export const RenderGroupType = {
    /**
     * 整楼
     */
    building: "building",
}